import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import React from 'react';

import { customTypes } from '../../helpers';
import { Button } from '../../index';

import styles from './material-modal.module.scss';

function MaterialModal({ children, closeModal, ctaText, image, maxWidth, open }) {
  if (open) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = null;
  }

  const getImageStyle = () => {
    if (!image) {
      return {};
    }

    return typeof image === 'string'
      ? { backgroundImage: `url(${image})` }
      : {
          backgroundImage: `url(${image.src})`,
          backgroundPositionX: image.position.x,
          backgroundPositionY: image.position.y,
        };
  };

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      className={styles['material-modal']}
      maxWidth={maxWidth}
    >
      <div className={styles.content}>
        {image && <div className={styles['image-container']} style={getImageStyle()} />}
        <div className={styles.copy}>{children}</div>
        <div className={styles.cta}>
          <Button onClick={closeModal} variant="text">
            {ctaText}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

MaterialModal.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  contentLabel: PropTypes.string,
  ctaText: PropTypes.string.isRequired,
  image: customTypes.image,
  maxWidth: PropTypes.string,
  open: PropTypes.bool,
};

MaterialModal.defaultProps = {
  maxWidth: 'sm',
};

export default MaterialModal;
